/// <reference types="vite/client" />

/**
 * Freezes an object in development to surface accidental mutations early.
 * In production builds, returns the original reference without freezing
 * to avoid the runtime cost of Object.freeze.
 */
export function freezeInDev<T extends object>(value: T): T {
  if (import.meta.env.DEV) {
    return Object.freeze(value);
  }
  return value;
}
